export default {"src":"/profile/_next/static/media/tree.1d2713f6.svg","height":180,"width":118,"blurWidth":0,"blurHeight":0};